import { useMemo } from 'react';
import { usePermissions } from 'context/PermissionsContext';
import { CALENDAR_PERMISSION_CODES } from 'permissions/constants/calendarPermissionCodes';
import { MODULE_KEY_MAP } from 'permissions/constants/moduleKeyMap';

export { CALENDAR_PERMISSION_CODES };

const usePermissionsCalendar = () => {
  const { permissionsLoading, hasPermission, hasModuleAccess } =
    usePermissions();

  return useMemo(
    () => ({
      loading: permissionsLoading,
      canAccessModule: hasModuleAccess(MODULE_KEY_MAP.CALENDAR),
      canViewSection: hasPermission(CALENDAR_PERMISSION_CODES.VIEW_SECTION),
      canViewOthers: hasPermission(CALENDAR_PERMISSION_CODES.VIEW_OTHERS_TASKS),
      canViewTaskDetail: hasPermission(CALENDAR_PERMISSION_CODES.TASK_DETAIL),
    }),
    [permissionsLoading, hasPermission, hasModuleAccess]
  );
};

export default usePermissionsCalendar;
